import React, { memo } from 'react';
import { useAppSelector } from 'ducks/hooks';
import { selectCardInfo } from 'ducks/modals/selectors';
import { CardInfoParams } from 'ducks/types/common-types';
import { BatchDefinitionParameterProps } from 'ducks/types/prop-types';
import { Pin } from 'modals/parameter-connections/component/Pin';
import { shallowEqual } from 'react-redux';

import cn from 'modals/parameter-connections/component/Components.module.scss';

const BatchDefinitionParameterBase = ({ params, length, handleCreateConnection }: BatchDefinitionParameterProps) => {
  const card_info = useAppSelector(selectCardInfo, shallowEqual);

  const { batch_definition_item_name: name, batch_definition_item_id: owner_id } = card_info;

  return (
    <div>
      <div className={cn.parameterConnectionWrapper}>{name}</div>
      {params?.map((el) => (
        <Pin key={el.parameter_name} owner_id={owner_id} pinParams={el} classId={`${el.parameter_name}00`} />
      ))}
      {length ? (
        length?.map(({ parameter_name }: CardInfoParams) => (
          <Pin
            key={parameter_name}
            owner_id={owner_id}
            handleCreateConnection={handleCreateConnection}
            status={false}
          />
        ))
      ) : (
        <Pin owner_id={owner_id} handleCreateConnection={handleCreateConnection} status={false} />
      )}
    </div>
  );
};

export const BatchDefinitionParameter = memo(BatchDefinitionParameterBase);
